import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AddPaymentsService } from 'src/app/services/transactions/add-payments.service';
import { GlobalService } from 'src/app/services/shared/global.service';

@Component({
  selector: 'app-add-idf-payment',
  templateUrl: './add-idf-payment.component.html',
  styleUrls: ['./add-idf-payment.component.css']
})
export class AddIdfPaymentComponent implements OnInit{
  page: number = 1;
  count: number = 0;
  public errorMessage: string | null = null;
  public successMessage: string | null = null;
  unpaidIdfCharges: any[] = [];
  searchText: string = '';
  public isLoading: boolean = false;
  public isInProgress: boolean = false;
  isProcessing: boolean = false;
  submitted: boolean = false;
  form!: FormGroup;
  @ViewChild('AddPaymentModal') modalElement!: ElementRef;
  public make:string='';
  public model:string='';
  public vehicle_id:string='';
  public chassis_no:string='';
  public bl_no:string='';

  constructor(
    private addPaymentsService: AddPaymentsService,
    private globalService: GlobalService,
    private formBuilder: FormBuilder
  ){
    this.form = this.formBuilder.group({
      amount:['',Validators.required]
    });
  }

  ngOnInit(): void {
    this.isLoading=true;
    this.getUnpaidIdfCharges();
  }

  getUnpaidIdfCharges(): void {
    this.addPaymentsService.fetchUnpaidIdfCharges()
    .subscribe({
      next: (response) => {
        if(response.status==='success'){
          this.unpaidIdfCharges = response.data;
          this.isLoading=false;
        }else if(response.status==='no_data'){
           this.errorMessage=response.message;
           this.isLoading=false;
        }else{
          this.errorMessage="Sorry, a problem was encountered while processing your request. Please refresh the page and try again!";
          this.isLoading=false;
        }
      },
      error: (error) => {
        this.errorMessage=error;
        this.isLoading=false;
      }
    });
  }

  pageChangeEvent(event: number){
    this.page = event;
  }

  onSearchTextChange(event: Event) {
    this.searchText = (event.target as HTMLInputElement).value;
    this.page = 1; // Reset to page 1 after applying filter
  }

  openModal(vehicle_id: string,chassis_no: string,make:string,model:string,bl_no:string){
    this.make = make;
    this.model = model;
    this.vehicle_id = vehicle_id;
    this.chassis_no = chassis_no;
    this.bl_no = bl_no;

    if (this.modalElement) {
      (<any>$(this.modalElement.nativeElement)).modal('show');
    }
  }

  closeModal():void {
    if (this.modalElement) {
      (<any>$(this.modalElement.nativeElement)).modal('hide');
    }
  }

  submit():void {
    this.submitted = true;
    this.isInProgress=true;

    if (this.form.valid) {

      const payload = {
        vehicle_id: this.vehicle_id,
        chassis_no: this.chassis_no,
        bl_no: this.bl_no,
        ...this.form.value,
      };

      this.addPaymentsService.postIdfPayment(payload)
      .subscribe({
        next: (response) => {
          if(response.status==='success'){
            this.submitted = false;
            this.isInProgress=false;
            this.errorMessage=null;
            this.form.reset();
            this.globalService.setGlobalSuccessMessage(response.message);
            this.closeModal();
            // Refresh the list
            this.getUnpaidIdfCharges();
          }else{
            this.submitted = false;
            this.isInProgress=false;
            this.errorMessage=response.message;
            this.closeModal();
          }
        },
        error: (error) => {
          this.submitted = false;
          this.isInProgress=false;
          this.errorMessage=error;
          this.closeModal();
        }
      });
    }else{
      this.isInProgress=false;
    }
  }
}
